import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWarning = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M0.56639 30.1936C1.26838 31.3187 2.48655 32 3.81831 32H28.1817C29.5135 32 30.7316 31.3187 31.4336 30.1936C32.1253 29.058 32.1872 27.6645 31.5988 26.4774L19.4067 2.10578C18.7564 0.815463 17.4556 0 16 0C14.5444 0 13.2437 0.815463 12.5933 2.10579L0.401235 26.4774C-0.187203 27.6748 -0.125272 29.058 0.56639 30.1936Z",
			fill: "var(--snackbar-icon-warning-bg, #FFF7D8)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.7992 12.4995H18.1989V26.7983H13.7992V12.4995Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.38936 27.7581C5.87193 28.5316 6.70935 29 7.62486 29H24.3732C25.2887 29 26.1262 28.5316 26.6087 27.7581C27.0842 26.9774 27.1268 26.0193 26.7223 25.2032L18.341 8.44772C17.8939 7.56063 16.9997 7 15.999 7C14.9984 7 14.1042 7.56063 13.6571 8.44773L5.27583 25.2032C4.87131 26.0265 4.91388 26.9774 5.38936 27.7581ZM17.0636 14.0684V20.8316C17.0636 21.4207 16.5881 21.8961 15.999 21.8961C15.41 21.8961 14.9345 21.4207 14.9345 20.8316V14.0684C14.9345 13.4794 15.41 13.0038 15.999 13.0038C16.5881 13.0038 17.0636 13.4794 17.0636 14.0684ZM14.9345 24.7135V23.94C14.9345 23.351 15.41 22.8755 15.999 22.8755C16.5881 22.8755 17.0636 23.351 17.0636 23.94V24.7135C17.0636 25.2955 16.5881 25.778 15.999 25.778C15.41 25.778 14.9345 25.2955 14.9345 24.7135Z",
			fill: "var(--snackbar-icon-warning-color, #FFBA45)"
		})
	]
});
export default SvgWarning;
